/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnalyzeDefectRequest } from '../../models/analyze-defect-request';
import { BaseWorkPackageDto } from '../../models/base-work-package-dto';

export interface BulkAnalyzeDefects$Params {
      body: AnalyzeDefectRequest
}

export function bulkAnalyzeDefects(http: HttpClient, rootUrl: string, params: BulkAnalyzeDefects$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BaseWorkPackageDto>>> {
  const rb = new RequestBuilder(rootUrl, bulkAnalyzeDefects.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BaseWorkPackageDto>>;
    })
  );
}

bulkAnalyzeDefects.PATH = '/v0/FocoosAI';
